import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useNewOrders() {
  const [newOrdersCount, setNewOrdersCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const loadNewOrdersCount = useCallback(async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      // Count new product orders
      const { count, error } = await supabase
        .from("product_orders")
        .select("*", { count: "exact", head: true })
        .eq("is_new", true)
        .eq("status", "completed");

      if (error) throw error;
      setNewOrdersCount(count || 0);
    } catch (error) {
      console.error("Error loading new orders count:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Subscribe to realtime changes
  useEffect(() => {
    loadNewOrdersCount();

    // Subscribe to product_orders changes
    const channel = supabase
      .channel("new-orders-count")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "product_orders"
        },
        () => {
          loadNewOrdersCount();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [loadNewOrdersCount]);

  const markOrdersAsSeen = useCallback(async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      await supabase
        .from("product_orders")
        .update({ is_new: false })
        .eq("is_new", true);

      setNewOrdersCount(0);
    } catch (error) {
      console.error("Error marking orders as seen:", error);
    }
  }, []);

  return {
    newOrdersCount,
    loading,
    refreshCount: loadNewOrdersCount,
    markOrdersAsSeen
  };
}
